import { t } from '@lingui/macro';
import PropTypes from 'prop-types';

export const subtitle = (a) =>
  [(a.trigger_type || []).join(' / '), a.category].filter(Boolean).join(' · ');

export const statusLabel = (status) =>
  ({
    unhealthy: t`Unhealthy`,
    degraded: t`Degraded`,
    healthy: t`Healthy`,
    idle: t`No Activity`,
  }[status] || status);

export const healthRowsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      name: PropTypes.string,
      category: PropTypes.string,
      trigger_type: PropTypes.arrayOf(PropTypes.string),
      status: PropTypes.string,
      reason_code: PropTypes.string,
      succeeded: PropTypes.number,
      failed: PropTypes.number,
      blocked: PropTypes.number,
      total: PropTypes.number,
      by_status: PropTypes.objectOf(PropTypes.number),
      last_success_at: PropTypes.string,
      unhealthy_since: PropTypes.string,
    }),
  }),
);
